/**
 * Copied with love from Mobile app code 8-D
 * Only using the country code map for now
 * There is also a simple list, dial code map, and country name map
 */

export const COUNTRY_CODE_MAP = {
  AF: {
    name: 'Afghanistan',
    flag: '🇦🇫',
    code: 'AF',
    prefix: '93',
  },
  AX: {
    name: 'Åland Islands',
    flag: '🇦🇽',
    code: 'AX',
    prefix: '358',
  },
  AL: {
    name: 'Albania',
    flag: '🇦🇱',
    code: 'AL',
    prefix: '355',
  },
  DZ: {
    name: 'Algeria',
    flag: '🇩🇿',
    code: 'DZ',
    prefix: '213',
  },
  AS: {
    name: 'American Samoa',
    flag: '🇦🇸',
    code: 'AS',
    prefix: '1684',
  },
  AD: {
    name: 'Andorra',
    flag: '🇦🇩',
    code: 'AD',
    prefix: '376',
  },
  AO: {
    name: 'Angola',
    flag: '🇦🇴',
    code: 'AO',
    prefix: '244',
  },
  AI: {
    name: 'Anguilla',
    flag: '🇦🇮',
    code: 'AI',
    prefix: '1264',
  },
  AQ: {
    name: 'Antarctica',
    flag: '🇦🇶',
    code: 'AQ',
    prefix: '672',
  },
  AG: {
    name: 'Antigua and Barbuda',
    flag: '🇦🇬',
    code: 'AG',
    prefix: '1268',
  },
  AR: {
    name: 'Argentina',
    flag: '🇦🇷',
    code: 'AR',
    prefix: '54',
  },
  AM: {
    name: 'Armenia',
    flag: '🇦🇲',
    code: 'AM',
    prefix: '374',
  },
  AW: {
    name: 'Aruba',
    flag: '🇦🇼',
    code: 'AW',
    prefix: '297',
  },
  AU: {
    name: 'Australia',
    flag: '🇦🇺',
    code: 'AU',
    prefix: '61',
  },
  AT: {
    name: 'Austria',
    flag: '🇦🇹',
    code: 'AT',
    prefix: '43',
  },
  AZ: {
    name: 'Azerbaijan',
    flag: '🇦🇿',
    code: 'AZ',
    prefix: '994',
  },
  BS: {
    name: 'Bahamas',
    flag: '🇧🇸',
    code: 'BS',
    prefix: '1242',
  },
  BH: {
    name: 'Bahrain',
    flag: '🇧🇭',
    code: 'BH',
    prefix: '973',
  },
  BD: {
    name: 'Bangladesh',
    flag: '🇧🇩',
    code: 'BD',
    prefix: '880',
  },
  BB: {
    name: 'Barbados',
    flag: '🇧🇧',
    code: 'BB',
    prefix: '1246',
  },
  BY: {
    name: 'Belarus',
    flag: '🇧🇾',
    code: 'BY',
    prefix: '375',
  },
  BE: {
    name: 'Belgium',
    flag: '🇧🇪',
    code: 'BE',
    prefix: '32',
  },
  BZ: {
    name: 'Belize',
    flag: '🇧🇿',
    code: 'BZ',
    prefix: '501',
  },
  BJ: {
    name: 'Benin',
    flag: '🇧🇯',
    code: 'BJ',
    prefix: '229',
  },
  BM: {
    name: 'Bermuda',
    flag: '🇧🇲',
    code: 'BM',
    prefix: '1441',
  },
  BT: {
    name: 'Bhutan',
    flag: '🇧🇹',
    code: 'BT',
    prefix: '975',
  },
  BO: {
    name: 'Bolivia, Plurinational State of bolivia',
    flag: '🇧🇴',
    code: 'BO',
    prefix: '591',
  },
  BA: {
    name: 'Bosnia and Herzegovina',
    flag: '🇧🇦',
    code: 'BA',
    prefix: '387',
  },
  BW: {
    name: 'Botswana',
    flag: '🇧🇼',
    code: 'BW',
    prefix: '267',
  },
  BV: {
    name: 'Bouvet Island',
    flag: '🇧🇻',
    code: 'BV',
    prefix: '47',
  },
  BR: {
    name: 'Brazil',
    flag: '🇧🇷',
    code: 'BR',
    prefix: '55',
  },
  IO: {
    name: 'British Indian Ocean Territory',
    flag: '🇮🇴',
    code: 'IO',
    prefix: '246',
  },
  BN: {
    name: 'Brunei Darussalam',
    flag: '🇧🇳',
    code: 'BN',
    prefix: '673',
  },
  BG: {
    name: 'Bulgaria',
    flag: '🇧🇬',
    code: 'BG',
    prefix: '359',
  },
  BF: {
    name: 'Burkina Faso',
    flag: '🇧🇫',
    code: 'BF',
    prefix: '226',
  },
  BI: {
    name: 'Burundi',
    flag: '🇧🇮',
    code: 'BI',
    prefix: '257',
  },
  KH: {
    name: 'Cambodia',
    flag: '🇰🇭',
    code: 'KH',
    prefix: '855',
  },
  CM: {
    name: 'Cameroon',
    flag: '🇨🇲',
    code: 'CM',
    prefix: '237',
  },
  CA: {
    name: 'Canada',
    flag: '🇨🇦',
    code: 'CA',
    prefix: '1',
  },
  CV: {
    name: 'Cape Verde',
    flag: '🇨🇻',
    code: 'CV',
    prefix: '238',
  },
  KY: {
    name: 'Cayman Islands',
    flag: '🇰🇾',
    code: 'KY',
    prefix: '345',
  },
  CF: {
    name: 'Central African Republic',
    flag: '🇨🇫',
    code: 'CF',
    prefix: '236',
  },
  TD: {
    name: 'Chad',
    flag: '🇹🇩',
    code: 'TD',
    prefix: '235',
  },
  CL: {
    name: 'Chile',
    flag: '🇨🇱',
    code: 'CL',
    prefix: '56',
  },
  CN: {
    name: 'China',
    flag: '🇨🇳',
    code: 'CN',
    prefix: '86',
  },
  CX: {
    name: 'Christmas Island',
    flag: '🇨🇽',
    code: 'CX',
    prefix: '61',
  },
  CC: {
    name: 'Cocos (Keeling) Islands',
    flag: '🇨🇨',
    code: 'CC',
    prefix: '61',
  },
  CO: {
    name: 'Colombia',
    flag: '🇨🇴',
    code: 'CO',
    prefix: '57',
  },
  KM: {
    name: 'Comoros',
    flag: '🇰🇲',
    code: 'KM',
    prefix: '269',
  },
  CG: {
    name: 'Congo',
    flag: '🇨🇬',
    code: 'CG',
    prefix: '242',
  },
  CD: {
    name: 'Congo, The Democratic Republic of the Congo',
    flag: '🇨🇩',
    code: 'CD',
    prefix: '243',
  },
  CK: {
    name: 'Cook Islands',
    flag: '🇨🇰',
    code: 'CK',
    prefix: '682',
  },
  CR: {
    name: 'Costa Rica',
    flag: '🇨🇷',
    code: 'CR',
    prefix: '506',
  },
  CI: {
    name: "Cote d'Ivoire",
    flag: '🇨🇮',
    code: 'CI',
    prefix: '225',
  },
  HR: {
    name: 'Croatia',
    flag: '🇭🇷',
    code: 'HR',
    prefix: '385',
  },
  CU: {
    name: 'Cuba',
    flag: '🇨🇺',
    code: 'CU',
    prefix: '53',
  },
  CY: {
    name: 'Cyprus',
    flag: '🇨🇾',
    code: 'CY',
    prefix: '357',
  },
  CZ: {
    name: 'Czech Republic',
    flag: '🇨🇿',
    code: 'CZ',
    prefix: '420',
  },
  DK: {
    name: 'Denmark',
    flag: '🇩🇰',
    code: 'DK',
    prefix: '45',
  },
  DJ: {
    name: 'Djibouti',
    flag: '🇩🇯',
    code: 'DJ',
    prefix: '253',
  },
  DM: {
    name: 'Dominica',
    flag: '🇩🇲',
    code: 'DM',
    prefix: '1767',
  },
  DO: {
    name: 'Dominican Republic',
    flag: '🇩🇴',
    code: 'DO',
    prefix: '1849',
  },
  EC: {
    name: 'Ecuador',
    flag: '🇪🇨',
    code: 'EC',
    prefix: '593',
  },
  EG: {
    name: 'Egypt',
    flag: '🇪🇬',
    code: 'EG',
    prefix: '20',
  },
  SV: {
    name: 'El Salvador',
    flag: '🇸🇻',
    code: 'SV',
    prefix: '503',
  },
  GQ: {
    name: 'Equatorial Guinea',
    flag: '🇬🇶',
    code: 'GQ',
    prefix: '240',
  },
  ER: {
    name: 'Eritrea',
    flag: '🇪🇷',
    code: 'ER',
    prefix: '291',
  },
  EE: {
    name: 'Estonia',
    flag: '🇪🇪',
    code: 'EE',
    prefix: '372',
  },
  ET: {
    name: 'Ethiopia',
    flag: '🇪🇹',
    code: 'ET',
    prefix: '251',
  },
  FK: {
    name: 'Falkland Islands (Malvinas)',
    flag: '🇫🇰',
    code: 'FK',
    prefix: '500',
  },
  FO: {
    name: 'Faroe Islands',
    flag: '🇫🇴',
    code: 'FO',
    prefix: '298',
  },
  FJ: {
    name: 'Fiji',
    flag: '🇫🇯',
    code: 'FJ',
    prefix: '679',
  },
  FI: {
    name: 'Finland',
    flag: '🇫🇮',
    code: 'FI',
    prefix: '358',
  },
  FR: {
    name: 'France',
    flag: '🇫🇷',
    code: 'FR',
    prefix: '33',
  },
  GF: {
    name: 'French Guiana',
    flag: '🇬🇫',
    code: 'GF',
    prefix: '594',
  },
  PF: {
    name: 'French Polynesia',
    flag: '🇵🇫',
    code: 'PF',
    prefix: '689',
  },
  TF: {
    name: 'French Southern Territories',
    flag: '🇹🇫',
    code: 'TF',
    prefix: '262',
  },
  GA: {
    name: 'Gabon',
    flag: '🇬🇦',
    code: 'GA',
    prefix: '241',
  },
  GM: {
    name: 'Gambia',
    flag: '🇬🇲',
    code: 'GM',
    prefix: '220',
  },
  GE: {
    name: 'Georgia',
    flag: '🇬🇪',
    code: 'GE',
    prefix: '995',
  },
  DE: {
    name: 'Germany',
    flag: '🇩🇪',
    code: 'DE',
    prefix: '49',
  },
  GH: {
    name: 'Ghana',
    flag: '🇬🇭',
    code: 'GH',
    prefix: '233',
  },
  GI: {
    name: 'Gibraltar',
    flag: '🇬🇮',
    code: 'GI',
    prefix: '350',
  },
  GR: {
    name: 'Greece',
    flag: '🇬🇷',
    code: 'GR',
    prefix: '30',
  },
  GL: {
    name: 'Greenland',
    flag: '🇬🇱',
    code: 'GL',
    prefix: '299',
  },
  GD: {
    name: 'Grenada',
    flag: '🇬🇩',
    code: 'GD',
    prefix: '1473',
  },
  GP: {
    name: 'Guadeloupe',
    flag: '🇬🇵',
    code: 'GP',
    prefix: '590',
  },
  GU: {
    name: 'Guam',
    flag: '🇬🇺',
    code: 'GU',
    prefix: '1671',
  },
  GT: {
    name: 'Guatemala',
    flag: '🇬🇹',
    code: 'GT',
    prefix: '502',
  },
  GG: {
    name: 'Guernsey',
    flag: '🇬🇬',
    code: 'GG',
    prefix: '44',
  },
  GN: {
    name: 'Guinea',
    flag: '🇬🇳',
    code: 'GN',
    prefix: '224',
  },
  GW: {
    name: 'Guinea-Bissau',
    flag: '🇬🇼',
    code: 'GW',
    prefix: '245',
  },
  GY: {
    name: 'Guyana',
    flag: '🇬🇾',
    code: 'GY',
    prefix: '592',
  },
  HT: {
    name: 'Haiti',
    flag: '🇭🇹',
    code: 'HT',
    prefix: '509',
  },
  HM: {
    name: 'Heard Island and Mcdonald Islands',
    flag: '🇭🇲',
    code: 'HM',
    prefix: '672',
  },
  VA: {
    name: 'Holy See (Vatican City State)',
    flag: '🇻🇦',
    code: 'VA',
    prefix: '379',
  },
  HN: {
    name: 'Honduras',
    flag: '🇭🇳',
    code: 'HN',
    prefix: '504',
  },
  HK: {
    name: 'Hong Kong',
    flag: '🇭🇰',
    code: 'HK',
    prefix: '852',
  },
  HU: {
    name: 'Hungary',
    flag: '🇭🇺',
    code: 'HU',
    prefix: '36',
  },
  IS: {
    name: 'Iceland',
    flag: '🇮🇸',
    code: 'IS',
    prefix: '354',
  },
  IN: {
    name: 'India',
    flag: '🇮🇳',
    code: 'IN',
    prefix: '91',
  },
  ID: {
    name: 'Indonesia',
    flag: '🇮🇩',
    code: 'ID',
    prefix: '62',
  },
  IR: {
    name: 'Iran, Islamic Republic of Persian Gulf',
    flag: '🇮🇷',
    code: 'IR',
    prefix: '98',
  },
  IQ: {
    name: 'Iraq',
    flag: '🇮🇶',
    code: 'IQ',
    prefix: '964',
  },
  IE: {
    name: 'Ireland',
    flag: '🇮🇪',
    code: 'IE',
    prefix: '353',
  },
  IM: {
    name: 'Isle of Man',
    flag: '🇮🇲',
    code: 'IM',
    prefix: '44',
  },
  IL: {
    name: 'Israel',
    flag: '🇮🇱',
    code: 'IL',
    prefix: '972',
  },
  IT: {
    name: 'Italy',
    flag: '🇮🇹',
    code: 'IT',
    prefix: '39',
  },
  JM: {
    name: 'Jamaica',
    flag: '🇯🇲',
    code: 'JM',
    prefix: '1876',
  },
  JP: {
    name: 'Japan',
    flag: '🇯🇵',
    code: 'JP',
    prefix: '81',
  },
  JE: {
    name: 'Jersey',
    flag: '🇯🇪',
    code: 'JE',
    prefix: '44',
  },
  JO: {
    name: 'Jordan',
    flag: '🇯🇴',
    code: 'JO',
    prefix: '962',
  },
  KZ: {
    name: 'Kazakhstan',
    flag: '🇰🇿',
    code: 'KZ',
    prefix: '7',
  },
  KE: {
    name: 'Kenya',
    flag: '🇰🇪',
    code: 'KE',
    prefix: '254',
  },
  KI: {
    name: 'Kiribati',
    flag: '🇰🇮',
    code: 'KI',
    prefix: '686',
  },
  KP: {
    name: "Korea, Democratic People's Republic of Korea",
    flag: '🇰🇵',
    code: 'KP',
    prefix: '850',
  },
  KR: {
    name: 'Korea, Republic of South Korea',
    flag: '🇰🇷',
    code: 'KR',
    prefix: '82',
  },
  XK: {
    name: 'Kosovo',
    flag: '🇽🇰',
    code: 'XK',
    prefix: '383',
  },
  KW: {
    name: 'Kuwait',
    flag: '🇰🇼',
    code: 'KW',
    prefix: '965',
  },
  KG: {
    name: 'Kyrgyzstan',
    flag: '🇰🇬',
    code: 'KG',
    prefix: '996',
  },
  LA: {
    name: 'Laos',
    flag: '🇱🇦',
    code: 'LA',
    prefix: '856',
  },
  LV: {
    name: 'Latvia',
    flag: '🇱🇻',
    code: 'LV',
    prefix: '371',
  },
  LB: {
    name: 'Lebanon',
    flag: '🇱🇧',
    code: 'LB',
    prefix: '961',
  },
  LS: {
    name: 'Lesotho',
    flag: '🇱🇸',
    code: 'LS',
    prefix: '266',
  },
  LR: {
    name: 'Liberia',
    flag: '🇱🇷',
    code: 'LR',
    prefix: '231',
  },
  LY: {
    name: 'Libyan Arab Jamahiriya',
    flag: '🇱🇾',
    code: 'LY',
    prefix: '218',
  },
  LI: {
    name: 'Liechtenstein',
    flag: '🇱🇮',
    code: 'LI',
    prefix: '423',
  },
  LT: {
    name: 'Lithuania',
    flag: '🇱🇹',
    code: 'LT',
    prefix: '370',
  },
  LU: {
    name: 'Luxembourg',
    flag: '🇱🇺',
    code: 'LU',
    prefix: '352',
  },
  MO: {
    name: 'Macao',
    flag: '🇲🇴',
    code: 'MO',
    prefix: '853',
  },
  MK: {
    name: 'Macedonia',
    flag: '🇲🇰',
    code: 'MK',
    prefix: '389',
  },
  MG: {
    name: 'Madagascar',
    flag: '🇲🇬',
    code: 'MG',
    prefix: '261',
  },
  MW: {
    name: 'Malawi',
    flag: '🇲🇼',
    code: 'MW',
    prefix: '265',
  },
  MY: {
    name: 'Malaysia',
    flag: '🇲🇾',
    code: 'MY',
    prefix: '60',
  },
  MV: {
    name: 'Maldives',
    flag: '🇲🇻',
    code: 'MV',
    prefix: '960',
  },
  ML: {
    name: 'Mali',
    flag: '🇲🇱',
    code: 'ML',
    prefix: '223',
  },
  MT: {
    name: 'Malta',
    flag: '🇲🇹',
    code: 'MT',
    prefix: '356',
  },
  MH: {
    name: 'Marshall Islands',
    flag: '🇲🇭',
    code: 'MH',
    prefix: '692',
  },
  MQ: {
    name: 'Martinique',
    flag: '🇲🇶',
    code: 'MQ',
    prefix: '596',
  },
  MR: {
    name: 'Mauritania',
    flag: '🇲🇷',
    code: 'MR',
    prefix: '222',
  },
  MU: {
    name: 'Mauritius',
    flag: '🇲🇺',
    code: 'MU',
    prefix: '230',
  },
  YT: {
    name: 'Mayotte',
    flag: '🇾🇹',
    code: 'YT',
    prefix: '262',
  },
  MX: {
    name: 'Mexico',
    flag: '🇲🇽',
    code: 'MX',
    prefix: '52',
  },
  FM: {
    name: 'Micronesia, Federated States of Micronesia',
    flag: '🇫🇲',
    code: 'FM',
    prefix: '691',
  },
  MD: {
    name: 'Moldova',
    flag: '🇲🇩',
    code: 'MD',
    prefix: '373',
  },
  MC: {
    name: 'Monaco',
    flag: '🇲🇨',
    code: 'MC',
    prefix: '377',
  },
  MN: {
    name: 'Mongolia',
    flag: '🇲🇳',
    code: 'MN',
    prefix: '976',
  },
  ME: {
    name: 'Montenegro',
    flag: '🇲🇪',
    code: 'ME',
    prefix: '382',
  },
  MS: {
    name: 'Montserrat',
    flag: '🇲🇸',
    code: 'MS',
    prefix: '1664',
  },
  MA: {
    name: 'Morocco',
    flag: '🇲🇦',
    code: 'MA',
    prefix: '212',
  },
  MZ: {
    name: 'Mozambique',
    flag: '🇲🇿',
    code: 'MZ',
    prefix: '258',
  },
  MM: {
    name: 'Myanmar',
    flag: '🇲🇲',
    code: 'MM',
    prefix: '95',
  },
  NA: {
    name: 'Namibia',
    flag: '🇳🇦',
    code: 'NA',
    prefix: '264',
  },
  NR: {
    name: 'Nauru',
    flag: '🇳🇷',
    code: 'NR',
    prefix: '674',
  },
  NP: {
    name: 'Nepal',
    flag: '🇳🇵',
    code: 'NP',
    prefix: '977',
  },
  NL: {
    name: 'Netherlands',
    flag: '🇳🇱',
    code: 'NL',
    prefix: '31',
  },
  AN: {
    name: 'Netherlands Antilles',
    flag: '',
    code: 'AN',
    prefix: '599',
  },
  NC: {
    name: 'New Caledonia',
    flag: '🇳🇨',
    code: 'NC',
    prefix: '687',
  },
  NZ: {
    name: 'New Zealand',
    flag: '🇳🇿',
    code: 'NZ',
    prefix: '64',
  },
  NI: {
    name: 'Nicaragua',
    flag: '🇳🇮',
    code: 'NI',
    prefix: '505',
  },
  NE: {
    name: 'Niger',
    flag: '🇳🇪',
    code: 'NE',
    prefix: '227',
  },
  NG: {
    name: 'Nigeria',
    flag: '🇳🇬',
    code: 'NG',
    prefix: '234',
  },
  NU: {
    name: 'Niue',
    flag: '🇳🇺',
    code: 'NU',
    prefix: '683',
  },
  NF: {
    name: 'Norfolk Island',
    flag: '🇳🇫',
    code: 'NF',
    prefix: '672',
  },
  MP: {
    name: 'Northern Mariana Islands',
    flag: '🇲🇵',
    code: 'MP',
    prefix: '1670',
  },
  NO: {
    name: 'Norway',
    flag: '🇳🇴',
    code: 'NO',
    prefix: '47',
  },
  OM: {
    name: 'Oman',
    flag: '🇴🇲',
    code: 'OM',
    prefix: '968',
  },
  PK: {
    name: 'Pakistan',
    flag: '🇵🇰',
    code: 'PK',
    prefix: '92',
  },
  PW: {
    name: 'Palau',
    flag: '🇵🇼',
    code: 'PW',
    prefix: '680',
  },
  PS: {
    name: 'Palestinian Territory, Occupied',
    flag: '🇵🇸',
    code: 'PS',
    prefix: '970',
  },
  PA: {
    name: 'Panama',
    flag: '🇵🇦',
    code: 'PA',
    prefix: '507',
  },
  PG: {
    name: 'Papua New Guinea',
    flag: '🇵🇬',
    code: 'PG',
    prefix: '675',
  },
  PY: {
    name: 'Paraguay',
    flag: '🇵🇾',
    code: 'PY',
    prefix: '595',
  },
  PE: {
    name: 'Peru',
    flag: '🇵🇪',
    code: 'PE',
    prefix: '51',
  },
  PH: {
    name: 'Philippines',
    flag: '🇵🇭',
    code: 'PH',
    prefix: '63',
  },
  PN: {
    name: 'Pitcairn',
    flag: '🇵🇳',
    code: 'PN',
    prefix: '64',
  },
  PL: {
    name: 'Poland',
    flag: '🇵🇱',
    code: 'PL',
    prefix: '48',
  },
  PT: {
    name: 'Portugal',
    flag: '🇵🇹',
    code: 'PT',
    prefix: '351',
  },
  PR: {
    name: 'Puerto Rico',
    flag: '🇵🇷',
    code: 'PR',
    prefix: '1939',
  },
  QA: {
    name: 'Qatar',
    flag: '🇶🇦',
    code: 'QA',
    prefix: '974',
  },
  RO: {
    name: 'Romania',
    flag: '🇷🇴',
    code: 'RO',
    prefix: '40',
  },
  RU: {
    name: 'Russia',
    flag: '🇷🇺',
    code: 'RU',
    prefix: '7',
  },
  RW: {
    name: 'Rwanda',
    flag: '🇷🇼',
    code: 'RW',
    prefix: '250',
  },
  RE: {
    name: 'Reunion',
    flag: '🇷🇪',
    code: 'RE',
    prefix: '262',
  },
  BL: {
    name: 'Saint Barthelemy',
    flag: '🇧🇱',
    code: 'BL',
    prefix: '590',
  },
  SH: {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    flag: '🇸🇭',
    code: 'SH',
    prefix: '290',
  },
  KN: {
    name: 'Saint Kitts and Nevis',
    flag: '🇰🇳',
    code: 'KN',
    prefix: '1869',
  },
  LC: {
    name: 'Saint Lucia',
    flag: '🇱🇨',
    code: 'LC',
    prefix: '1758',
  },
  MF: {
    name: 'Saint Martin',
    flag: '🇲🇫',
    code: 'MF',
    prefix: '590',
  },
  PM: {
    name: 'Saint Pierre and Miquelon',
    flag: '🇵🇲',
    code: 'PM',
    prefix: '508',
  },
  VC: {
    name: 'Saint Vincent and the Grenadines',
    flag: '🇻🇨',
    code: 'VC',
    prefix: '1784',
  },
  WS: {
    name: 'Samoa',
    flag: '🇼🇸',
    code: 'WS',
    prefix: '685',
  },
  SM: {
    name: 'San Marino',
    flag: '🇸🇲',
    code: 'SM',
    prefix: '378',
  },
  ST: {
    name: 'Sao Tome and Principe',
    flag: '🇸🇹',
    code: 'ST',
    prefix: '239',
  },
  SA: {
    name: 'Saudi Arabia',
    flag: '🇸🇦',
    code: 'SA',
    prefix: '966',
  },
  SN: {
    name: 'Senegal',
    flag: '🇸🇳',
    code: 'SN',
    prefix: '221',
  },
  RS: {
    name: 'Serbia',
    flag: '🇷🇸',
    code: 'RS',
    prefix: '381',
  },
  SC: {
    name: 'Seychelles',
    flag: '🇸🇨',
    code: 'SC',
    prefix: '248',
  },
  SL: {
    name: 'Sierra Leone',
    flag: '🇸🇱',
    code: 'SL',
    prefix: '232',
  },
  SG: {
    name: 'Singapore',
    flag: '🇸🇬',
    code: 'SG',
    prefix: '65',
  },
  SK: {
    name: 'Slovakia',
    flag: '🇸🇰',
    code: 'SK',
    prefix: '421',
  },
  SI: {
    name: 'Slovenia',
    flag: '🇸🇮',
    code: 'SI',
    prefix: '386',
  },
  SB: {
    name: 'Solomon Islands',
    flag: '🇸🇧',
    code: 'SB',
    prefix: '677',
  },
  SO: {
    name: 'Somalia',
    flag: '🇸🇴',
    code: 'SO',
    prefix: '252',
  },
  ZA: {
    name: 'South Africa',
    flag: '🇿🇦',
    code: 'ZA',
    prefix: '27',
  },
  SS: {
    name: 'South Sudan',
    flag: '🇸🇸',
    code: 'SS',
    prefix: '211',
  },
  GS: {
    name: 'South Georgia and the South Sandwich Islands',
    flag: '🇬🇸',
    code: 'GS',
    prefix: '500',
  },
  ES: {
    name: 'Spain',
    flag: '🇪🇸',
    code: 'ES',
    prefix: '34',
  },
  LK: {
    name: 'Sri Lanka',
    flag: '🇱🇰',
    code: 'LK',
    prefix: '94',
  },
  SD: {
    name: 'Sudan',
    flag: '🇸🇩',
    code: 'SD',
    prefix: '249',
  },
  SR: {
    name: 'Suriname',
    flag: '🇸🇷',
    code: 'SR',
    prefix: '597',
  },
  SJ: {
    name: 'Svalbard and Jan Mayen',
    flag: '🇸🇯',
    code: 'SJ',
    prefix: '47',
  },
  SZ: {
    name: 'Swaziland',
    flag: '🇸🇿',
    code: 'SZ',
    prefix: '268',
  },
  SE: {
    name: 'Sweden',
    flag: '🇸🇪',
    code: 'SE',
    prefix: '46',
  },
  CH: {
    name: 'Switzerland',
    flag: '🇨🇭',
    code: 'CH',
    prefix: '41',
  },
  SY: {
    name: 'Syrian Arab Republic',
    flag: '🇸🇾',
    code: 'SY',
    prefix: '963',
  },
  TW: {
    name: 'Taiwan',
    flag: '🇹🇼',
    code: 'TW',
    prefix: '886',
  },
  TJ: {
    name: 'Tajikistan',
    flag: '🇹🇯',
    code: 'TJ',
    prefix: '992',
  },
  TZ: {
    name: 'Tanzania, United Republic of Tanzania',
    flag: '🇹🇿',
    code: 'TZ',
    prefix: '255',
  },
  TH: {
    name: 'Thailand',
    flag: '🇹🇭',
    code: 'TH',
    prefix: '66',
  },
  TL: {
    name: 'Timor-Leste',
    flag: '🇹🇱',
    code: 'TL',
    prefix: '670',
  },
  TG: {
    name: 'Togo',
    flag: '🇹🇬',
    code: 'TG',
    prefix: '228',
  },
  TK: {
    name: 'Tokelau',
    flag: '🇹🇰',
    code: 'TK',
    prefix: '690',
  },
  TO: {
    name: 'Tonga',
    flag: '🇹🇴',
    code: 'TO',
    prefix: '676',
  },
  TT: {
    name: 'Trinidad and Tobago',
    flag: '🇹🇹',
    code: 'TT',
    prefix: '1868',
  },
  TN: {
    name: 'Tunisia',
    flag: '🇹🇳',
    code: 'TN',
    prefix: '216',
  },
  TR: {
    name: 'Turkey',
    flag: '🇹🇷',
    code: 'TR',
    prefix: '90',
  },
  TM: {
    name: 'Turkmenistan',
    flag: '🇹🇲',
    code: 'TM',
    prefix: '993',
  },
  TC: {
    name: 'Turks and Caicos Islands',
    flag: '🇹🇨',
    code: 'TC',
    prefix: '1649',
  },
  TV: {
    name: 'Tuvalu',
    flag: '🇹🇻',
    code: 'TV',
    prefix: '688',
  },
  UG: {
    name: 'Uganda',
    flag: '🇺🇬',
    code: 'UG',
    prefix: '256',
  },
  UA: {
    name: 'Ukraine',
    flag: '🇺🇦',
    code: 'UA',
    prefix: '380',
  },
  AE: {
    name: 'United Arab Emirates',
    flag: '🇦🇪',
    code: 'AE',
    prefix: '971',
  },
  GB: {
    name: 'United Kingdom',
    flag: '🇬🇧',
    code: 'GB',
    prefix: '44',
  },
  US: {
    name: 'United States',
    flag: '🇺🇸',
    code: 'US',
    prefix: '1',
  },
  UY: {
    name: 'Uruguay',
    flag: '🇺🇾',
    code: 'UY',
    prefix: '598',
  },
  UZ: {
    name: 'Uzbekistan',
    flag: '🇺🇿',
    code: 'UZ',
    prefix: '998',
  },
  VU: {
    name: 'Vanuatu',
    flag: '🇻🇺',
    code: 'VU',
    prefix: '678',
  },
  VE: {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    flag: '🇻🇪',
    code: 'VE',
    prefix: '58',
  },
  VN: {
    name: 'Vietnam',
    flag: '🇻🇳',
    code: 'VN',
    prefix: '84',
  },
  VG: {
    name: 'Virgin Islands, British',
    flag: '🇻🇬',
    code: 'VG',
    prefix: '1284',
  },
  VI: {
    name: 'Virgin Islands, U.S.',
    flag: '🇻🇮',
    code: 'VI',
    prefix: '1340',
  },
  WF: {
    name: 'Wallis and Futuna',
    flag: '🇼🇫',
    code: 'WF',
    prefix: '681',
  },
  YE: {
    name: 'Yemen',
    flag: '🇾🇪',
    code: 'YE',
    prefix: '967',
  },
  ZM: {
    name: 'Zambia',
    flag: '🇿🇲',
    code: 'ZM',
    prefix: '260',
  },
  ZW: {
    name: 'Zimbabwe',
    flag: '🇿🇼',
    code: 'ZW',
    prefix: '263',
  },
}

export const DEFAULT_COUNTRY = COUNTRY_CODE_MAP.US
